module.exports = __webpack_public_path__ + "img/social-media.ee4ef236.svg";